import React from "react";
import GroupUserData from "./table/GroupUserData"
export default function ScheduleGroupUser(ID) {
  console.log("IDDD", ID)
  return (
    <div>
      <h2 class=" mb-4">
        <div
          class="
            relative
            flex
            items-center
            w-full
            py-4
            px-3
            font-Montserrat
            text-base text-blue-200 text-left
            bg-transparent
            border-0
            rounded-none
            transition
            focus:outline-none
            "
        >
          <svg
            className="mr-2 hover:rotate-180 font-medium"
            width="15"
            height="10"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
              stroke="#1F78B4"
              stroke-width="2"
            />
          </svg>{" "}
          Group/User
        </div>
      </h2>
      <div className="flex flex-wrap   pl-3 mt-2  rounded-xl">
        <div className="flex flex-wrap float-left ">
          <div className=" text-gray-400 py-4 font-medium "> Name:</div>
          <div className="mt-4 mr-8 ml-2 text-gray-700 font-semibold">
          {ID.id.group?.name}
          </div>
        </div>
      </div>
    
      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <GroupUserData id={ID} />
        </div>
      </div>
    </div>
  );
}
